const convertToDisplayName = (name: string) => (name ? `The ${name}` : name);

const convertToSlug = (name: string) =>
  encodeURI(name.toLowerCase().split(' ').join('-'));

export { convertToDisplayName, convertToSlug };
